<template>
  <Form :model="formItem" :label-width="150">
    <FormItem label="平台">
      <Input
        v-model="formItem.groupCode"
        placeholder="请输入"
        style="width: 60%"
      ></Input>
    </FormItem>
    <FormItem v-show="formItem.stype == 1" label="门店ID">
      <Input
        v-model="formItem.groupCode"
        placeholder="请输入"
        style="width: 60%"
      ></Input>
    </FormItem>
    <FormItem label="门店名称">
      <Input
        v-model="formItem.businessInfo"
        placeholder="请输入"
        style="width: 60%"
      ></Input>
    </FormItem>
    <FormItem label="门店渠道">
      <Input
        v-model="formItem.channelCode"
        placeholder="请输入"
        style="width: 60%"
      ></Input>
    </FormItem>
    <FormItem label="服务商编号">
      <Input
        v-model="formItem.lecienceName"
        placeholder="请输入"
        style="width: 60%"
      ></Input>
    </FormItem>
    <FormItem label="服务商分类">
      <Input
        v-model="formItem.lecienceCode"
        placeholder="请输入"
        style="width: 60%"
      ></Input>
    </FormItem>
    <FormItem label="服务商名称">
      <Input
        v-model="formItem.name"
        placeholder="请输入"
        style="width: 60%"
      ></Input>
    </FormItem>
    <FormItem label="服务商渠道">
      <Input
        v-model="formItem.name"
        placeholder="请输入"
        style="width: 60%"
      ></Input>
    </FormItem>
    <FormItem label="服务商角色">
      <Input
        v-model="formItem.parentCode"
        placeholder="请输入"
        style="width: 60%"
      ></Input>
    </FormItem>
    <FormItem>
      <Button type="primary" @click="add">{{
        mode === "edit" ? "修改" : "添加"
      }}</Button>
      <Button style="margin-left: 8px" @click="back">取消</Button>
    </FormItem>
  </Form>
</template>
<script>
import { mapGetters } from "vuex";
import axios from 'axios';
export default {
  data() {
    return {
      mode: "add",
      formItem: {
        addr: "",
        businessInfo: "",
        channelCode: "",
        cityId: "",
        cityName: "",
        contacTperson: "",
        contactMobile: "",
        dealerLevel: "",
        elnDealerCode: "",
        elnDealerName: "",
        groupCode: "",
        lecienceCode: "",
        lecienceImgUrl: "",
        lecienceName: "",
        name: "",
        parentCode: "",
        provinceId: "",
        provinceName: [],
        remark: "",
        stype: "",
      },
      provinceList: [],
      province: "",
      cityList: [],
      city: "",
      countyList: [],
      county: "",
      uploading: false,
    };
  },
  computed: {
    ...mapGetters({
      shopInfo: "merchant/getShopInfoQuery",
    }),
  },
  watch: {
    shopInfo: {
      deep: true,
      handler: function (newv, oldv) {
        if (newv) {
          this.formItem = Object.assign(newv);
        }
      },
    },
  },
  created() {
    // 区分模式
    console.log(this.$route.query.code);
    // 编辑模式
    if (this.$route.query.code) {
      this.mode = "edit";
      this.getDetail();
    } else {
      this.mode = "add";
    }

    this.getArea("provinceList");
  },
  methods: {
    getDetail() {
      this.$store
        .dispatch("merchant/shopInfoQuery", {
          code: this.$route.query.code,
        })
        .then(() => {})
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {});
    },
    changeStype(value) {
      if (value == 0) {
        this.formItem.groupCode = "000";
      } else {
        this.formItem.groupCode = "";
      }
    },
    selectArea(type, value) {
      const kv = value.split("||");
      if (type === "province") {
        this.getArea("cityList", kv[0], kv[1]);
      } else if (type === "city") {
        this.getArea("countyList", kv[0], kv[1]);
      } else if (type === "county") {
        console.log(this.province, this.city, this.county);
        const p_kv = this.province.split("||");
        const c_kv = this.city.split("||");

        this.formItem.provinceId = p_kv[0];
        this.formItem.provinceName = p_kv[1];
        this.formItem.cityId = c_kv[0];
        this.formItem.cityName = c_kv[1];
      }
    },
    getArea(target, code = "", label = "") {
      this.$http({
        url: axios.defaults.baseURL + "base/area/query",
        method: "GET",
        params: { code },
      })
        .then((res) => res.data)
        .then((data) => {
          if (data.code == 200) {
            this.$set(this, target, data.data);
          } else {
            console.log(data.message);
          }
        })
        .catch((err) => console.error(err));
    },
    beforeUpload(d) {
      // let size = d.size;
      // let type = d.type;
      // if (size > 2048000) {
      //   this.$Message.error("图片不可大于2M");
      //   return false; //停止上传
      // }
      // if (type != "image/png" && type != "image/jpg" && type != "image/jpeg") {
      //   this.$Message.error("仅支持jpg/png");
      //   return false; //停止上传
      // }
      this.uploading = true;
    },
    uploadSuccess(response, file, fileList) {
      this.uploading = false;
      if(response.code == 200){
        this.formItem.lecienceImgUrl = response.data.url;
      }else{
        this.$Message.error(response.message || "上传失败");
      }
    },
    uploadError() {
      this.formItem.lecienceImgUrl = "";
      this.uploading = false;
      this.$Message.error("上传失败");
    },
    // 添加
    add() {
      console.log(this.formItem, "formItem");
      this.$Spin.show();

      this.$store
        .dispatch(
          this.mode == "edit"
            ? "merchant/shopInfoUpdate"
            : "merchant/shopInfoAdd",
          this.formItem
        )
        .then((res) => {
          if (res.code == 200) {
            this.$Message.success("添加成功");
            setTimeout(this.back, 3000);
          } else {
            this.$Message.error(res.message || "添加失败，请稍后重试！");
          }
        })
        .catch((err) => {
          console.error(err);
          this.$Message.error(err);
        })
        .finally(this.$Spin.hide);
    },
    back() {
      this.$router.back();
    },
  },
};
</script>
<style>
.ivu-input {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/merchant/relation/create.vue